import React from 'react';
import { Star } from 'lucide-react';
export function SocialProofBanner() {
  return <div className="sticky top-0 z-50 w-full bg-brand-teal text-white py-2 px-4 shadow-md" data-id="element-130">
      <div className="max-w-4xl mx-auto flex items-center justify-center text-center text-xs sm:text-sm font-medium" data-id="element-131">
        <Star className="w-4 h-4 text-brand-gold fill-brand-gold mr-2 flex-shrink-0" data-id="element-132" />
        <span data-id="element-133">
          Más de 8,500 dueños en México y Chile ya transformaron sus paseos este
          mes. Protocolo Bio-Conductual 2026.
        </span>
      </div>
    </div>;
}